import forms from '@/translations/en/projects/project-forms';

export default {
  forms,
  // Legacy translations; do not add to below list
  noProjects: {
    line1: 'You currently have no projects.',
    line2: 'Create your first project to get started.',
    noPermission: 'Contact your organisation admin to get started.',
  },
  searchForItems: 'Search for items',
  searchItems: 'Search items',
  newSite: 'Add new site',
  newProjectTitle: 'Create New Project',
  search: 'Search by {type} name',
  projectManager: 'Project Manager',
  sites: 'Sites',
  project: 'project',
  projectName: 'Project name',
  archived: 'Archived',
  archivedItems: 'Show archived {type}s',
  percentageUsed: '{percentage}% used',
  site: 'Site',
  siteName: 'Site name',
  financialData: {
    budgetSpent: 'Budget spent',
    budgetRemaining: 'Budget remaining',
    budgetVariations: 'Budget variations',
    budgetTotal: 'Budget total',
  },
  contextMenu: {
    newSite: 'Add new site',
    edit: 'Edit project',
    view: 'View project details',
    manageUsers: 'Manage project members',
    manageSiteUsers: 'Manage site members',
    viewUsers: 'View project users',
    viewSiteUsers: 'View site users',
    viewCashflow: 'View cashflow',
    archive: 'Archive project',
    unarchive: 'Unarchive project',
  },
  createProject: {
    title: 'Create New Project',
    basicInfo: {
      title: 'Project Details',
      subtitle: 'Provide the basic project information for this project.',
    },
    userInfo: {
      title: 'Project Members',
      subtitle: 'Add members to this project. Assign roles and set permissions.',
    },
    image: '{action} project image',
  },
  editProject: {
    title: 'Edit Project',
    basicInfo: {
      title: 'Basic Information',
      subtitle: 'Provide the basic project information for this project.',
    },
    form: {
      projectName: 'Project name',
      projectStatus: 'Project status',
      projectImage: 'Project image',
    },
    deleteImageModal: {
      title: 'Remove project image',
      content: 'Are you sure you want to remove this project image?',
    },
    unsavedChangesModal: {
      title: 'Discard changes?',
      content: "You have unsaved changes. They'll be lost if you continue.",
      confirmLabel: 'Discard & Close',
      cancelLabel: 'Keep Editing',
    },
    archiveProjectModal: {
      archiveContent:
        'This will move this project to ‘Archived’ state, hiding it from view. You can view any archived projects by checking the “View archived projects” toggle on the projects screen.',
      unarchiveContent: 'Are you sure you want to unarchive this project?',
      confirm: 'Confirm',
      archive: 'archive',
      unarchive: 'unarchive',
    },
    updateSuccess: {
      title: 'Project Updated',
      content: 'Project has been updated successfully',
    },
    imageUploadSuccess: {
      title: 'Image Uploaded',
      content: 'Image has uploaded successfully',
    },
    imageDeleteSuccess: {
      title: 'Image Removed',
      content: 'Image has been removed successfully',
    },
    imageMutationError: {
      title: 'Image Update Failed',
      content: 'Updating the image failed. Please try again.',
    },
    userAddedSuccess: {
      title: 'User Invited',
      content: 'User has been invited successfully',
    },
    userRemovedSuccess: {
      title: 'User Removed',
      content: 'User has been removed successfully',
    },
    userAlreadyAdded: {
      title: 'User Exists',
      content: 'This user already has this role within this project.',
    },
    roleAdded: {
      title: 'Role added',
      content: 'The {role} role has been added for {email}.',
    },
    roleRemoved: {
      title: 'Role removed',
      content: 'The {role} role has been removed for {email}.',
    },
    roleChangeFailed: {
      title: 'Could not update role',
      content: 'Something went wrong changing this role — please try again.',
    },
  },
  users: {
    userAlreadyAddedAsProjectManager: {
      title: 'User Exists as Project Manager',
      content: 'This user is already added as the project manager on this project.',
    },
    userAlreadyAdded: {
      title: 'User Exists',
      content: 'This user is already added with the same role',
    },
    pendingUserSingleRole: {
      title: 'Invite Not Accepted',
      content:
        'This user needs to accept their invite before they can be given more than one role.',
    },
  },
  cashflow: {
    title: 'Cashflow',
    allSites: 'All Sites',
    viewProjectCashflow: 'View project cashflow',
    viewSiteCashflow: 'View site cashflow',
    refresh: 'Refresh data',
    downloadReport: 'Download Report',
    startDate: 'Start date',
    endDate: 'End date',
    table: {
      headers: {
        site: 'Site',
        flow: 'Flow',
        current: 'Current',
      },
      rows: {
        overheads: 'Overheads',
        cashIn: 'Cash in',
        cashOut: 'Cash out',
        vatLiability: 'VAT Liability',
        net: 'Net',
        allSites: 'All Project Sites',
      },
      noData: 'No data available for the selected period',
    },
    totals: {
      totalCashIn: 'Total cash-in',
      totalCashOut: 'Total cash-out',
      totalOverheads: 'Total overheads',
      netIncome: '{type} net income',
      site: 'Site',
      project: 'Project',
      currentPeriod: 'Current period',
    },
    cumulativeNet: 'Cumulative {type} Net',
    actual: 'Actual',
    projected: 'Projected',
    claimBanner: {
      description:
        'In order to view future predicted cashflow, we require you complete your BOQ claim period on your BOQ sheet for line items.',
      action: 'Fill in claim periods',
    },
    exportCashflow: {
      loadingText: 'Preparing file for export\nThis could take a few seconds...',
      exportSuccess: {
        title: 'Export successful',
        content: '{name} cashflow has been successfully exported',
      },
    },
  },
  manageSiteUsers: {
    title: 'Site members',
  },
};
